import { render, staticRenderFns } from "./BankAccount.vue?vue&type=template&id=17b130ba&"
import script from "./BankAccount.vue?vue&type=script&lang=ts&"
export * from "./BankAccount.vue?vue&type=script&lang=ts&"
import style0 from "./BankAccount.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports